import { useBreakpointValue } from "@gemini/core";
import { useEffect, useState } from "react";
export function useIsDesktopOrMobile() {
    const [desktopOrMobile, setDesktopOrMobile] = useState(undefined);
    const breakpoint = useBreakpointValue({ base: "mobile", lg: "desktop" });
    useEffect(() => {
        // This function detects and sets the device type
        const updateIsDesktop = () => {
            setDesktopOrMobile(breakpoint);
        };
        // First detection after mount
        updateIsDesktop();
        // Listen to resize events to update dynamically
        window.addEventListener("resize", updateIsDesktop);
        return () => {
            window.removeEventListener("resize", updateIsDesktop);
        };
    }, [breakpoint, desktopOrMobile]);
    return desktopOrMobile;
}
